import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Gallery.css";

// Bundle every gallery image so we can sample a fresh teaser on each visit.
const importAll = (r) => r.keys().map(r);
const images = importAll(
  require.context("../assets/images/gallery", false, /\.(png|jpe?g|svg)$/)
);

// One feature tile + four supporting tiles fill the asymmetric grid exactly.
const TILE_COUNT = 5;

const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// A static editorial mosaic (no carousel): a large feature photo plus a grid of
// supporting shots, the whole block linking through to the full gallery.
const Gallery = () => {
  const [tiles, setTiles] = useState([]);

  useEffect(() => {
    setTiles(shuffle(images).slice(0, TILE_COUNT));
  }, []);

  return (
    <Link
      to="/full-gallery"
      className="gallery-mosaic"
      aria-label="View the full gallery"
    >
      {tiles.map((src, i) => (
        <div key={i} className="gallery-mosaic__tile">
          <img
            src={src}
            alt="SSS Powerlifting athlete competing"
            className="gallery-mosaic__img"
            loading="lazy"
            decoding="async"
          />
        </div>
      ))}
    </Link>
  );
};

export default Gallery;
